import * as types from "./actionTypes";

export const addOrUpdateAccessCredentials = (workspaceKey, resourceKey, accessCode) => async (dispatch, getState) => {
    dispatch({ type: types.ACCESS_CREDENTIALS_UPDATED, payload: {workspaceKey, resourceKey, accessCode} });
}

export const deleteAccessCredentials = (workspaceKey, resourceKey) => async (dispatch, getState) => {
    dispatch({ type: types.ACCESS_CODE_DELETED, payload: {workspaceKey, resourceKey} });
}